import React from 'react';
import { FaCalendarAlt } from 'react-icons/fa';
import '../../styles/components/YearSelector.css';

/**
 * Componente reutilizable para seleccionar año
 * Diseñado para ser usado de manera independiente por agentes autónomos
 *
 * @param {Object} props
 * @param {number} props.selectedYear - Año actualmente seleccionado
 * @param {Function} props.onYearChange - Callback cuando cambia el año
 * @param {Array} props.yearOptions - Array de opciones de año
 * @param {string} props.label - Etiqueta del selector (opcional)
 * @param {string} props.className - Clase CSS adicional (opcional)
 * @param {boolean} props.showIcon - Mostrar icono de calendario (default: true)
 */
const YearSelector = ({
    selectedYear,
    onYearChange,
    yearOptions = [],
    label = 'Año',
    className = '',
    showIcon = true
}) => {
    const handleChange = (e) => {
        const year = parseInt(e.target.value);
        onYearChange(year);
    };

    return (
        <div className={`year-selector-container ${className}`}>
            <label htmlFor="year-select" className="year-selector-label">
                {showIcon && <FaCalendarAlt className="year-selector-icon" />}
                {label}
            </label>
            <select
                id="year-select"
                value={selectedYear}
                onChange={handleChange}
                className="year-selector-select"
            >
                {yearOptions.map((option) => (
                    <option
                        key={option.value}
                        value={option.value}
                        className={option.isCurrentYear ? 'current-year-option' : ''}
                    >
                        {option.label}
                        {option.isCurrentYear ? ' (Actual)' : ''}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default YearSelector;
